import { Discount } from "./Discount";
import { DiscountTarget, DiscountType } from "./RawCost";


export class CryptoDiscount extends Discount
{
    constructor()
    {
        super({
            Target: DiscountTarget.WholeBasket,
            Type: DiscountType.LimitedPercent,
            Name: "płatność w Bitcoin",
            Code: "crypto",
            Value: 15,
            Limit: 300,
            IsVisible: true,
        });
    }
}
